export const Crown = ({ className = "w-8 h-6" }) => (
  <svg viewBox="0 0 64 44" className={className} fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="crownGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#E8C87A" />
        <stop offset="55%" stopColor="#C9A24B" />
        <stop offset="100%" stopColor="#99732B" />
      </linearGradient>
    </defs>
    <path d="M6 34 L10 13 L21 25 L32 5 L43 25 L54 13 L58 34 Z" fill="url(#crownGold)" />
    <circle cx="10" cy="10" r="3.2" fill="#E8C87A" />
    <circle cx="32" cy="4.5" r="3.6" fill="#E8C87A" />
    <circle cx="54" cy="10" r="3.2" fill="#E8C87A" />
    <rect x="5" y="35" width="54" height="4.5" rx="2.25" fill="url(#crownGold)" />
  </svg>
);

export const LogoLockup = ({ compact = false }) => (
  <a href="/" data-testid="nav-brand-logo" className="flex items-center gap-3 group">
    <Crown className={`${compact ? "w-7 h-5" : "w-9 h-7"} crown-glow transition-transform duration-500 group-hover:-translate-y-0.5`} />
    <span className="leading-none">
      <span className="block font-display font-bold tracking-[0.14em] text-[#FBF8F2] text-sm sm:text-base">
        COLLISION QUEENS
      </span>
      <span className="block font-data text-[10px] tracking-[0.42em] text-[#0E7C86] mt-1">
        CONNECT
      </span>
    </span>
  </a>
);
